import React, { Suspense } from 'react';
import { useTypedSelector } from '@hooks';
import { useAuth } from '@hooks/useAuth';
import { useDebounced } from '@helpers/useDebounced';

const ShareAssetModal = React.lazy(() => import('./ShareAssetModal'));

export default function ShareAssetModalContainer() {
  const { user } = useAuth();
  const modalState = useTypedSelector(({ modal }) => modal.shareAssetModal);
  const visibleDebounced = useDebounced(modalState?.visible, 300, false);
  const visible = modalState?.visible || visibleDebounced;
  if (!modalState || !visible || !user) return null;

  return (
    <Suspense fallback={null}>
      <ShareAssetModal {...modalState} key={modalState.reviewId} />
    </Suspense>
  );
}
